import { render } from "./IndividualPlan.vue?vue&type=template&id=51411d66&scoped=true&ts=true"
import script from "./IndividualPlan.vue?vue&type=script&lang=ts"
export * from "./IndividualPlan.vue?vue&type=script&lang=ts"

import "./IndividualPlan.vue?vue&type=style&index=0&id=51411d66&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51411d66"]])

export default __exports__